'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _base = require('./base');

var _base2 = _interopRequireDefault(_base);

var _getParent = require('../helpers/traversal/get-parent');

var _getParent2 = _interopRequireDefault(_getParent);

var _addClass = require('../helpers/dom/add-class');

var _addClass2 = _interopRequireDefault(_addClass);

var _removeClass = require('../helpers/dom/remove-class');

var _removeClass2 = _interopRequireDefault(_removeClass);

var _debounce = require('../helpers/util/debounce');

var _debounce2 = _interopRequireDefault(_debounce);

var _hasClass = require('../helpers/dom/has-class');

var _hasClass2 = _interopRequireDefault(_hasClass);

var _breakpoint = require('../helpers/dom/breakpoint');

var _fixedPanel = require('./fixed-panel');

var _fixedPanel2 = _interopRequireDefault(_fixedPanel);

var _panelCarousel = require('./panel-carousel');

var _panelCarousel2 = _interopRequireDefault(_panelCarousel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * # KPI
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Key Performance Indicator
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @example
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * new KPI(el, {
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *    // ...
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *  }
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * });
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @module components/kpi.js
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */

var KPI = function (_BaseComponent) {
  _inherits(KPI, _BaseComponent);

  /**
   * KPI constructor.
   * @param {Element} el
   * @param {Object} params
   */
  function KPI(el) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    _classCallCheck(this, KPI);

    var _this = _possibleConstructorReturn(this, _BaseComponent.call(this, el, params));

    if (!el) {
      return _possibleConstructorReturn(_this);
    }

    if ((0, _hasClass2.default)(_this.el, 'spark-kpi--tabs')) {
      _this._hasTabs = true;
    }

    _this._bindEventListenerCallbacks();
    _this._addEventListeners();
    _this._calcBreakpoint();
    _this._updateOrientation();
    _this._initFixedPanel(el, params);
    _this._initPanelCarousel(el, params);
    return _this;
  }

  /**
   * If using a locked panel create a Fixed Panel Component and pass along config options
   */


  KPI.prototype._initFixedPanel = function _initFixedPanel() {
    if (this.lockPanel === true) {
      (0, _addClass2.default)(this.el, 'spark-panel--fixed');
      (0, _addClass2.default)(this.el, 'spark-panel--shadow-0');
      (0, _addClass2.default)(this.el, 'spark-panel--border-0');
      this.fixedPanel = new _fixedPanel2.default(this.el, {
        condenseOnScroll: this.condenseOnScroll,
        unlockBreakPoint: this.stackBreakPoint,
        fixToBottom: this.fixToBottom,
        customCondenseClass: this.customCondenseClass,
        scrolledToEl: this.scrolledToEl,
        hideOnScroll: this.hideOnScroll || false,
        headerEl: this.headerEl
      });
    }
  };

  /**
   * Add Panel Carousel Functionality pass parameters to the them
   */


  KPI.prototype._initPanelCarousel = function _initPanelCarousel() {
    if (!(0, _hasClass2.default)(this.el, '.spark-panel-carousel')) {
      (0, _addClass2.default)(this.el, 'spark-panel-carousel');
    }

    if (!(0, _hasClass2.default)(this.el.querySelector('.spark-kpi__list'), 'spark-panel-carousel__list')) {
      (0, _addClass2.default)(this.el.querySelector('.spark-kpi__list'), 'spark-panel-carousel__list');
    }

    if (!(0, _hasClass2.default)(this.el.querySelector('.spark-kpi__item'), 'spark-panel-carousel__item')) {
      var items = this.el.querySelectorAll('.spark-kpi__item');
      for (var i = 0; i < items.length; i++) {
        (0, _addClass2.default)(items[i], 'spark-panel-carousel__item');
      }
    }

    this.panelCarousel = new _panelCarousel2.default(this.el, {
      noCarouselBreakPoint: this.stackBreakPoint,
      singleCarouselAdvance: this.singleCarouselAdvance,
      controlBreakPoint: this.controlBreakPoint,
      nextLabel: this.nextLabel,
      previousLabel: this.previousLabel,
      hasTabs: this._hasTabs
    });
  };

  /**
   * Add event listeners
   */


  KPI.prototype._addEventListeners = function _addEventListeners() {
    window.addEventListener('resize', this._onResizeBound);
    if (this._hasTabs === true) {
      this._kpiList.addEventListener('click', this._onTabListClickBound);
    }
  };

  /**
   * Remove components
   */


  KPI.prototype.remove = function remove() {
    this.panelCarousel.remove();
    if (this.lockPanel === true) {
      this.lockPanel.remove();
    }
    _BaseComponent.prototype.remove.call(this);
  };

  /**
   * Remove event listeners
   */


  KPI.prototype._removeEventListeners = function _removeEventListeners() {
    window.removeEventListener('resize', this._onResizeBound);
    if (this._hasTabs === true) {
      this._kpiList.removeEventListener('click', this._onTabListClickBound);
    }
  };

  /**
   * Create bound versions of event listener callbacks and store them.
   * Otherwise we can't unbind from these events later because the
   * function signatures won't match.
   */


  KPI.prototype._bindEventListenerCallbacks = function _bindEventListenerCallbacks() {
    this._onResizeBound = (0, _debounce2.default)(this._onResize.bind(this), 90);
    this._onTabListClickBound = this._onTabListClick.bind(this);
  };

  /**
   * Store a reference to the tabs list, each tab and each panel.
   * Set which tab is active, or use the first.
   * @param {Element} el
   */


  KPI.prototype._cacheElements = function _cacheElements(el) {
    this.el = el;
    this._currentTab = this.el.querySelector('[aria-selected="true"]');
    this._kpiList = this.el.querySelector('.spark-kpi__list');
    this._kpiItems = this.el.querySelectorAll('.spark-kpi__item');
  };

  /**
   * Window resize event, keeps the carousel fresh... debounced from the listener. an event is passed to the method, but not used.
   */


  KPI.prototype._onResize = function _onResize() {
    this._calcBreakpoint();
    this._updateOrientation();
  };

  /**
   * Calculate the current Break point, update flags based on value
   */


  KPI.prototype._calcBreakpoint = function _calcBreakpoint() {
    this.currentBreakpoint = (0, _breakpoint.get)(window.innerWidth);
    var breakpoints = ['xs', 'sm', 'md', 'lg', 'xl'];
    var currentBreakIndex = breakpoints.indexOf(this.currentBreakpoint);
    var stackBreakIndex = breakpoints.indexOf(this.stackBreakPoint);

    if (currentBreakIndex <= stackBreakIndex && stackBreakIndex !== -1) {
      this._useStackedKPI = true;
    } else {
      this._useStackedKPI = false;
    }
  };

  /**
   * Update the orientation, row or stacked KPI
   */


  KPI.prototype._updateOrientation = function _updateOrientation() {
    if (this._useStackedKPI === true) {
      if (!(0, _hasClass2.default)(this.el, 'spark-kpi--column')) {
        (0, _addClass2.default)(this.el, 'spark-kpi--column');
        this.el.removeAttribute('data-overflow');
      }
    } else {
      (0, _removeClass2.default)(this.el, 'spark-kpi--column');
    }
  };

  /**
   * Tab KPI list was clicked.
   * @param  {clickEvent} _event click
   */


  KPI.prototype._onTabListClick = function _onTabListClick(_event) {
    _event.preventDefault();
    var tab = _event.target;

    if (tab.nodeName !== 'A') {
      tab = (0, _getParent2.default)(tab, 'a', this.el);
    }
    if (tab === false) {
      return;
    }

    if (this._currentTab !== null) {
      this._currentTab.removeAttribute('aria-selected');
    }

    tab.setAttribute('aria-selected', 'true');
    this._currentTab = tab;

    if (typeof this.onTabClick === 'function') {
      this.onTabClick(tab.getAttribute('aria-controls'), tab, this);
    }
  };

  return KPI;
}(_base2.default);

/**
 * Whitelisted parameters which can be set on construction.
 * @type {Array}
 */


KPI.prototype._whitelistedParams = ['singleCarouselAdvance', 'lockPanel', 'condenseOnScroll', 'customCondenseClass', 'unlockBreakPoint', 'stackBreakPoint', 'controlBreakPoint', 'fixToBottom', 'hideOnScroll', 'onTabClick', 'scrolledToEl', 'headerEl'];

/**
 * Default values for internal properties we will be setting.
 * These are set on each construction so we don't leak properties
 * into the prototype chain.
 * @type {Object}
 */
KPI.prototype.defaults = {
  el: null,
  singleCarouselAdvance: false,
  lockPanel: false,
  condenseOnScroll: true,
  customCondenseClass: 'spark-kpi--condensed',
  unlockBreakPoint: null,
  stackBreakPoint: 'xs',
  controlBreakPoint: 'xs',
  fixToBottom: null,
  hideOnScroll: false,
  onTabClick: null,
  nextLabel: 'show next',
  previousLabel: 'show previous',
  scrolledToEl: null,
  headerEl: null,
  _useControls: true,
  _useStackedKPI: false,
  _currentTab: null,
  _kpiItemsWidth: 0,
  _kpiWidth: 0,
  _kpiChange: 0,
  _positionX: 0,
  _forwardLimit: false,
  _backwardLimit: true,
  _overflow: false,
  _hasTabs: false,
  fixedPanel: null
};

exports.default = KPI;
module.exports = exports['default'];
//# sourceMappingURL=kpi.js.map



//////////////////
// WEBPACK FOOTER
// ./~/sabre-spark/js/dist/components/kpi.js
// module id = 1795
// module chunks = 0